var exports = {
  "Z": "x234b8571--d3b847--layout",
};

module.exports = exports;
